export default "__VITE_ASSET__CJwaFA6P__"